var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "valve-type" },
    [
      _c(
        "h5",
        {
          staticClass: "valve-type-heading",
          on: {
            click: function($event) {
              return _vm.onToggleGroup()
            }
          }
        },
        [_vm._v(_vm._s(_vm.valveGroupProp.name))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "valve-sets",
          class: { hidden: _vm.valveGroupProp.handle != _vm.valveGroupOpenProp }
        },
        _vm._l(_vm.viableValveSets, function(valveSet) {
          return _c(
            "div",
            {
              key: valveSet.id,
              staticClass: "valve-set",
              on: {
                click: function($event) {
                  return _vm.onValveSetSelected(valveSet)
                }
              }
            },
            [
              _c("img", {
                staticClass: "valve-set-img",
                class: { selected: valveSet == _vm.valveSetSelected },
                attrs: { src: valveSet.thumbnail, alt: valveSet.title }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "valve-label" }, [
                _vm._v(_vm._s(valveSet.title))
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.viableValveSets, function(valveSet) {
        return _c(
          "div",
          {
            key: valveSet.id,
            class: {
              hidden:
                valveSet != _vm.valveSetSelected ||
                _vm.valveGroupProp.handle != _vm.valveGroupOpenProp
            },
            attrs: { id: "vs-" + valveSet.id }
          },
          [
            _c("h6", { staticClass: "valve-set-finish-heading" }, [
              _vm._v("Select Valve Finish")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "valve-set-finishes" },
              [
                _vm._l(valveSet.finishes.slice(0, 5), function(finish) {
                  return _c(
                    "div",
                    {
                      key: finish.id,
                      staticClass: "valve-set-finish",
                      attrs: { title: finish.title }
                    },
                    [
                      _c("img", {
                        staticClass: "valve-set-finish-img",
                        class: { selected: finish == _vm.valveSelectedProp },
                        attrs: { src: finish.thumbnail, alt: finish.title },
                        on: {
                          click: function($event) {
                            return _vm.onValveSelected(finish)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "valve-label" }, [
                        _vm._v(_vm._s(finish.finish))
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.valveFinishBatchB, function(finish) {
                  return _c(
                    "div",
                    {
                      key: finish.id,
                      staticClass: "valve-set-finish valve-set-finish--hidden",
                      attrs: {
                        title: finish.title,
                        "data-finish-show-more": ""
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "valve-set-finish-img",
                        class: { selected: finish == _vm.valveSelectedProp },
                        attrs: { src: finish.thumbnail, alt: finish.title },
                        on: {
                          click: function($event) {
                            return _vm.onValveSelected(finish)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "valve-label" }, [
                        _vm._v(_vm._s(finish.finish))
                      ])
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            valveSet.finishes.length > 5
              ? _c(
                  "button",
                  {
                    staticClass: "btn valve-set-finishes__more",
                    on: {
                      click: function($event) {
                        return _vm.onFinishesShowMore(valveSet.id)
                      }
                    }
                  },
                  [_vm._v("\n\t\t\tShow more\n\t\t")]
                )
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }